<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.roleList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.setting.roleList')}}</div>
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="roles.length">
                            <thead>
                                <th>{{$t('form.setting.name')}}</th>
                                <th class="text-right">{{$t('form.setting.action')}}</th>
                            </thead>
                            <tbody>
                                <tr v-for="(role, index) in roles" :key="index" @dblclick="editRole(role.id)">
                                    <td>{{role.name}}</td>
                                    <td class="text-right">
                                        <button type="button" class="btn btn-info btn-sm" @click="editRole(role.id)"
                                            v-if="permissions.viewSettingsRoles">{{$t('button.edit')}}</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions'],

        data() {
            return {
                isLoading: false,
                fullPage: true,

                pagination: {
                    current_page: 1
                },

                roles: [],
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsRoles) {
                this.$router.push('/');
                return;
            }

            this.getRoles();
        },

        methods: {

            paginate() {
                this.getRoles();
            },

            getRoles() {
                this.isLoading = true;

                axios
                    .get('/api/roles?page=' + this.pagination.current_page)
                    .then(response => {
                        this.roles = response.data.data.data;
                        this.pagination = response.data.pagination;

                        this.isLoading = false;
                    })
                    .catch(error => {
                        // console.log(error.response);

                        this.isLoading = false;
                    });
            },

            editRole(id) {
                if (!this.permissions.viewSettingsRoles) return;

                this.$router.push({
                    name: 'RoleEdit',
                    params: {
                        id: id
                    }
                });
            }
        }
    }

</script>
